export default __webpack_public_path__ + "static/media/warning--falling-rocks-or-debris-right--g3.159ce905.png";